const makeUniq = (oddtype, outcome, special) => {
    return special
      ? `${oddtype}_${outcome}_${special || 0}`
      : `${oddtype}_${outcome}`;
  };
  
  export default makeUniq;
  